import { useState } from 'react'

import { useOutletContext } from 'react-router'

export const useCreateLayoutContext = () => {
  const [layout, setLayout] = useState<'normal' | 'fill'>('normal')
  return {
    layout,
    setLayout,
  }
}

export type LayoutContext = ReturnType<typeof useCreateLayoutContext>
export const useLayoutContext = () => useOutletContext<LayoutContext>()
